import React, {Component} from 'react';
import './css/programmatic.css';
import './css/styles.css';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
class Programmatic extends React.Component{
    render(){
        return(   
            <div>
                 <Helmet>
                <title>{this.props.value.title}</title>
                <meta
                    property="og:title"
                    content={this.props.value.title}
                />

                <meta
                    property="og:description"
                    content={this.props.value.description}
                />
                  <meta
                    property="og:url"
                    content={window.location.href}
                />
                <link rel="canonical" href={window.location.href} />
                <link rel="alternate" hreflang="en-in" href={window.location.href} />

            </Helmet>
                <div style={{position: 'relative',paddingTop:'80px'}}>
    <img src="/assets/images/aiplex-advertisement-programmatic.png" alt="programmatic"  title="programmatic" className="landing_img"/>
    <div className="landing_textpro">
        <h1 className="corporate ltext">
            <span className="first-letter">P</span>ROGRAMMATIC
        </h1>
    </div>
    <div className="bcdiv">
          <div className=" row">
          <td className="bchome">
          <a href="/" className="pl-1 bchome">Home</a>
          </td>
          <i className="bctext fa fa-angle-double-right pl-2" aria-hidden="true"></i>
          <td className="bcblue">
          <a href="/programmatic" className="pl-2 bcblue">Programmatic</a>
          </td>
          </div>
        </div>
</div>
<div className="hrline"></div>
<div className="Banner_BG">
    <div className="Banner_padding_prog">
        
        <div className="row pt-5">

            <div className="col-sm-6 pr-5">
                <p className="text-justify p16">Providing programmatic ad solutions to digital advertisers, publishers, and ad agencies across the globe. We help businesses to achieve business goals across all channels, devices and ad formats.
                </p>
                <img src="/assets/images/aiplex-ads-hour-glass.png" alt="hour glass"  title="hour glass" className="img_size pt-4"/>
            </div>
            <div className="col-sm-6 pl-5">
                <div>
                    <h3 className="corporate t24"><span className="first-letter">W</span>hite Label</h3>
                    <p className="p16">Creating fully customizable advertising platforms under your own brand name.

                    </p>
                    <img src="/assets/images/hrline.png"  alt="horizontal line"  title="horizontal line"  width="100%"/>
                </div>
                <div>
                    <h3 className="corporate pt-3 t24"><span className="first-letter">T</span>argeting</h3>
                    <p className="p16">Data-driven programmatic solutions helping run highly targeted campaigns.

                    </p>
                    <img src="/assets/images/hrline.png"  alt="horizontal line"  title="horizontal line"  width="100%"/>
                </div>
                <div>
                    <h3 className="corporate pt-3 t24"><span className="first-letter">M</span>onetizing</h3>
                    <p className="p16">Full-stack ad monetization solutions for digital publishers, advertisers & app developers.


                    </p>
                    <img src="/assets/images/hrline.png"  alt="horizontal line"  title="horizontal line"  width="100%"/>
                </div>
                <div>
                    <h3 className="corporate pt-3 t24"><span className="first-letter">M</span>anaging</h3>
                    <p className="p16">Manage omnichannel campaigns across mobile, display, native, video ad formats.
                    </p>
                    <img src="/assets/images/hrline.png"  alt="horizontal line"  title="horizontal line"  width="100%"/>
                </div>
            </div>


        </div>

    </div>
</div>
<div className="hrline"></div>
<div className="consult">
    <div className="bpadding2" style={{paddingBottom: '10px !important', paddingTop: '75px !important'}}>
        <div className="row">
            <div className="col-md-7">
                <h2><strong>Ready to get started?</strong></h2>
                <h3>Learn how AiPlex Digital can solve <br/>your more complex needs</h3>
            </div>
            <div className="col-md-3 float-bottom">
                <a className="btn btn-primary1 " href="#contact">Get In Touch</a>
            </div>
        </div>
    </div>
</div>
<div className="hrline"></div>
            </div>
             )
    }
}
Programmatic.propTypes = {
    value: PropTypes.object.isRequired
};
export default Programmatic